import React from 'react';

const TableVisibilityContext = React.createContext({
  showTables: false,
  setShowTables: () => {},
});

export function TableVisibilityProvider({ children, defaultOn = false }) {
  const [showTables, setShowTables] = React.useState(!!defaultOn);
  const value = React.useMemo(() => ({ showTables, setShowTables }), [showTables]);
  return (
    <TableVisibilityContext.Provider value={value}>
      {children}
    </TableVisibilityContext.Provider>
  );
}

export function useTableVisibility() {
  return React.useContext(TableVisibilityContext);
}
